import { render, staticRenderFns } from "./TextareaCom.vue?vue&type=template&id=5821954c&scoped=true&"
import script from "./TextareaCom.vue?vue&type=script&lang=js&"
export * from "./TextareaCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5821954c",
  null
  
)

export default component.exports